'use client'

import Image from 'next/image'
import Link from 'next/link'
import { pathOr } from 'ramda'

import { CartItem } from 'modules/cart'
import {
  getProductPrices,
  getProductUnitDetails,
  getQuantityUnit
} from 'modules/products'

import styles from './ProfileSaleOrdersProductCard.module.scss'

const ProfileSaleOrdersProductCard = ({
  item,
  href
}: {
  item: CartItem
  href: string
}) => {
  const { product } = item

  const unitDetails = getProductUnitDetails(product)

  const { currentPrice, promoPrice, defaultPrice } = getProductPrices({
    ...product,
    specialOfferPricing: {
      priceGross: {
        formatted: item.specialOfferValueGross?.formatted || '',
        value: item.specialOfferValueGross?.value || 0,
        symbol: item.specialOfferValueGross?.symbol || ''
      }
    },
    pricing: {
      priceGross: {
        formatted: item.valueGross?.formatted || '',
        value: item.valueGross?.value || 0,
        symbol: item.valueGross?.symbol || ''
      }
    }
  })

  const productImage = pathOr(
    '/static/photo-placeholder.svg',
    ['files', 0, 'thumbnailPathSmall'],
    product
  )

  const name = product.nameDescriptionShort || product.name || product.nameShort

  return (
    <Link className={styles.wrapper} href={href}>
      <Image src={productImage} alt={product.name} width={78} height={78} />
      <div className={styles.insideWrapper}>
        <div className={styles.productDetails}>
          <div className={styles.producerName}>{product?.producer?.name}</div>
          <div className={styles.productName}>{name}</div>
          <div className={styles.productUnitDetails}>{unitDetails}</div>
        </div>
        <div className={styles.counter}>{getQuantityUnit(item.orderedQuantity)}</div>
        <div className={styles.priceWrapper}>
          {promoPrice && (
            <div
              className={styles.oldPrice}
              dangerouslySetInnerHTML={{ __html: defaultPrice }}
            />
          )}
          <div
            className={styles.currentPrice}
            dangerouslySetInnerHTML={{ __html: currentPrice }}
          />
        </div>
      </div>
    </Link>
  )
}

export default ProfileSaleOrdersProductCard
